module.exports = __webpack_public_path__ + "img/Imageofpaymethod.00ba7cf4.png";